import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-services.component',
  imports: [RouterLink],
  templateUrl: './services.component.html',
})
export class ServicesComponent {

}
